<cm-first-login-form
    [fields]="fieldvalue"
    [featureFlagsData]="featureFlagsData"
    [organizationRoles]="organizationRoles"
    [locations]="locations"
    [type]="role"
    [organizationLabels]="organizationsLabel"
    [profile]="profile"
    (done)="completeRegistration($event)"
    [disabled]="disabled"
>
</cm-first-login-form>
